// CreateNews
import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  baseURL,
  baseURLV1,
  imageURL,
  privilegeURLV2,
} from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import TextField from "@material-ui/core/TextField";
import CropperImage from "../CropperImage";
import ImageUploading from "react-images-uploading";
import { Row, Col } from "react-bootstrap";
import ImageResize from "image-resize";
import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditBanner = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(
    intl.formatMessage({ id: "###", defaultMessage: "Edit Banner" })
  );
  const history = useHistory();
  const [item_image_path, setItem_image_path] = useState();
  const [item_image_path2, setItem_image_path2] = useState();
  const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");
  const [nameImageItem_image_path2, setNameImageItem_image_path2] = useState(
    ""
  );
  const [item_image_path3, setItem_image_path3] = useState();
  const [item_image_path4, setItem_image_path4] = useState();
  const [nameImageItem_image_path3, setNameImageItem_image_path3] = useState(
    ""
  );
  const [nameImageItem_image_path4, setNameImageItem_image_path4] = useState(
    ""
  );
  const [event, setEvent] = useState([]);
  const [symbolsArr] = useState(["e", "E", "+", "-"]);
  const [target, setTarget] = useState(null);
  const [listTarget, setListTarget] = useState([]);

  //const { user, setUser } = useState;

  const [title_th, setTitle_th] = useState();
  const [title_en, setTitle_en] = useState();
  const [description_th, setDescription_th] = useState();
  const [description_en, setDescription_en] = useState();
  const [type, setType] = useState("CONTENT");
  const [banner_category_id, setBanner_category_id] = useState(1);
  const [thumbnail_th, setThumbnail_th] = useState();
  const [thumbnail_en, setThumbnail_en] = useState();
  const [image_th, setImage_th] = useState();
  const [image_en, setImage_en] = useState();
  const [order_item, setOrder_item] = useState(1);
  const [privilegeSetting, setPrivilegeSettingData] = useState([]);
  const [popupstart, setPopupstart] = useState(null);
  const [popupend, setPopupend] = useState(null);
  const allData = [];

  const [reward, setReward] = useState(1);
  const [link, setLink] = useState("");

  const getPrivilegeSetting = async () => {
    //setPage(page);
    //let token = localStorage.getItem("Token");
    axios({
      method: "get",
      url: `${privilegeURLV2}/deal?page=1&limit=1000&campaign_id=22`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessTokenPrivilege}`,
      },
    })
      .then((res) => {
        if (res.message) {
          //history.push("/logout");
        } else {
          res.data.data.map((data, index) => {
            data = {
              id: data.id,
              dealTags: data.dealTags ? data.dealTags : [],
              dealRules: data.dealRules ? data.dealRules : [],
              deal_active: data.deal_active,

              campaign_id: data.id,
              deal_name: data.deal_name,
              deal_name_en: data.deal_name_en,
              deal_name_th: data.deal_name_th,
              deal_tags: data.deal_tags ? data.deal_tags : [],
              deal_expire_min: data.deal_expire_min,
              point: data.point,
              price: data.price ? data.price : 0,
              is_delivery: data.is_delivery,
              deal_detail_promote: data.deal_detail_promote,
              deal_detail_short: data.deal_detail_short,
              deal_detail_short_th: data.deal_detail_short_th,
              deal_detail_condition: data.deal_detail_condition,
              deal_logo: data.deal_logo,
              deal_image: data.deal_image,
            };
            allData.push(data);
          });
          setEvent(res.data.data);
        }

        /*var totalpage = Math.ceil(res.data.total / res.data.perPage);
            setTotalPage(totalpage);
            setTotalSize(res.data.total);
            setLimit(res.data.perPage);*/
        setPrivilegeSettingData(allData);
      })
      .catch((err) => {
        //window.location.assign("/logout");
      });
  };
  const { user } = useSelector((state) => state.auth);
  const { authToken, accessTokenPrivilege } = useSelector(
    (state) => state.auth
  );
  const getListTarget = async () => {
    const apiUrls = `${baseURLV1}/targetGroup?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // console.log(res.data.data)
        setListTarget(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
        }
      });
  };
  useEffect(() => {
    getListTarget();

    console.log(props);
    getPrivilegeSetting();
    setTitle_th(props.location.state.row.title_th);
    setTitle_en(props.location.state.row.title_en);
    setDescription_th(props.location.state.row.description_th);
    setDescription_en(props.location.state.row.description_en);
    setType(props.location.state.row.type);
    setOrder_item(props.location.state.row.order_item);
    /*setThumbnail_th(props.location.state.row.quota_member_per_day)
        setThumbnail_en(props.location.state.row.quota_member_per_week)
        setImage_th(props.location.state.row.quota_member_per_month)
        setImage_en(props.location.state.row.quota_member_per_year)*/
    setNameImageItem_image_path(props.location.state.row.thumbnail_th);
    setItem_image_path(props.location.state.row.thumbnail_th);
    setNameImageItem_image_path2(props.location.state.row.thumbnail_en);
    setItem_image_path2(props.location.state.row.thumbnail_en);
    setNameImageItem_image_path3(props.location.state.row.image_th);
    setItem_image_path3(props.location.state.row.image_th);
    setNameImageItem_image_path4(props.location.state.row.image_en);
    setItem_image_path4(props.location.state.row.image_en);
    setLink(props.location.state.row.link);
    setReward(props.location.state.row.privilege_id);
    console.log(props.location.state.row.group_condition_id);
    setTarget(props.location.state.row.group_condition_id);
    setPopupstart(props.location.state.row.popupstart);
    setPopupend(props.location.state.row.popupend);
  }, []);

  let dataTemp = [];
  const [images, setImages] = React.useState([]);
  const maxNumber = 10;
  /*const onChange = async (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
        if (imgCount == 0) {
            console.log('x', imgCount)
            setImgCount(imageList.length)
            await Promise.all(imageList.map(async (item, index) => {
                await handleUpload_image_Details(item.file)
            }))
        } else {
            console.log('y', imgCount)

            if (imageList.length > imgCount) {
                await Promise.all(imageList.map(async (item, index) => {
                    if (index > imgCount - 1) {
                        await handleUpload_image_Details(item.file)
                    }
                }))
                setImgCount(imageList.length)

            }
        }

        console.log('img', listImg)
    };*/

  const [stateItem_image_path, setStateItem_image_path] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });

  const [stateItem_image_path2, setStateItem_image_path2] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });

  const [stateItem_image_path3, setStateItem_image_path3] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });

  const [stateItem_image_path4, setStateItem_image_path4] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });

  /*const removeListIMG = (index) => {
        console.log(index)
        let arr = listImg
        arr.splice(index, 1);

        console.log(arr)

        setListImg(arr)
    }*/

  const handleChangeItem_image_path = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = "";
      handleImageUploadItem_image_path(file);
    }
  };

  const handleChangeItem_image_path2 = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = "";
      handleImageUploadItem_image_path2(file);
    }
  };

  const handleChangeItem_image_path3 = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = "";
      handleImageUploadItem_image_path3(file);
    }
  };

  const handleChangeItem_image_path4 = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = "";
      handleImageUploadItem_image_path4(file);
    }
  };

  const removeImageItem_image_path = async () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path("");
  };

  const removeImageItem_image_path2 = async () => {
    setStateItem_image_path2({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path2("");
  };

  const removeImageItem_image_path3 = async () => {
    setStateItem_image_path2({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path3("");
  };

  const removeImageItem_image_path4 = async () => {
    setStateItem_image_path2({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path4("");
  };

  const AlertError = (message) => {
    Swal.fire("Alert", message, "error");
  };

  const ISOString = (data) => {
    console.log(
      `${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`
    );
    return `${data.toString().substring(0, 10)} ${data
      .toString()
      .substring(11, 16)}`;
    // console.log(Date(data).toISOString())
  };

  const handleCancelUploadItem_image_path = () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
  };

  const handleImageUploadItem_image_path = async (file) => {
    const image = await resizeFile(file);
    console.log(image);
    console.log(file);
    imageResize.play(URL.createObjectURL(file)).then(async function(response) {
      console.log(response);
      const trans = dataURLtoFile(image, "img.png");
      var formdata = new FormData();
      let token = localStorage.getItem("Token");
      formdata.append("image", trans, URL.createObjectURL(trans));

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(`${baseURLV1}/upload`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result);
          setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
          });
          let fullPath = `${baseURL}/uploads/${res.filename}`;
          setItem_image_path(fullPath);
          setThumbnail_th(res.filename);
          setNameImageItem_image_path(fullPath);
        })
        .catch((error) => console.log("error", error));
    });
  };

  const handleImageUploadItem_image_path2 = async (file) => {
    const image = await resizeFile(file);
    console.log(image);
    console.log(file);
    imageResize.play(URL.createObjectURL(file)).then(async function(response) {
      console.log(response);
      const trans = dataURLtoFile(image, "img.png");
      var formdata = new FormData();
      let token = localStorage.getItem("Token");
      formdata.append("image", trans, URL.createObjectURL(trans));

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(`${baseURLV1}/upload`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result);
          setStateItem_image_path2({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
          });
          let fullPath = `${baseURL}/uploads/${res.filename}`;
          setItem_image_path2(fullPath);
          setThumbnail_en(res.filename);
          setNameImageItem_image_path2(fullPath);
        })
        .catch((error) => console.log("error", error));
    });
  };

  const handleImageUploadItem_image_path3 = async (file) => {
    const image = await resizeFile(file);
    console.log(image);
    console.log(file);
    imageResize.play(URL.createObjectURL(file)).then(async function(response) {
      console.log(response);
      const trans = dataURLtoFile(image, "img.png");
      var formdata = new FormData();
      let token = localStorage.getItem("Token");
      formdata.append("image", trans, URL.createObjectURL(trans));

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(`${baseURLV1}/upload`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result);
          setStateItem_image_path3({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
          });
          let fullPath = `${baseURL}/uploads/${res.filename}`;
          setItem_image_path3(fullPath);
          setImage_th(res.filename);
          setNameImageItem_image_path3(fullPath);
        })
        .catch((error) => console.log("error", error));
    });
  };

  const handleImageUploadItem_image_path4 = async (file) => {
    const image = await resizeFile(file);
    console.log(image);
    console.log(file);
    imageResize.play(URL.createObjectURL(file)).then(async function(response) {
      console.log(response);
      const trans = dataURLtoFile(image, "img.png");
      var formdata = new FormData();
      let token = localStorage.getItem("Token");
      formdata.append("image", trans, URL.createObjectURL(trans));

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(`${baseURLV1}/upload`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result);
          setStateItem_image_path4({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
          });
          let fullPath = `${baseURL}/uploads/${res.filename}`;
          setItem_image_path4(fullPath);
          setImage_en(res.filename);
          setNameImageItem_image_path4(fullPath);
        })
        .catch((error) => console.log("error", error));
    });
  };

  const imageResize = new ImageResize({
    format: "png", // ไฟล์รูปภาพเป็น png
    quality: 0.5, // ปรับขนาดไฟล์รูปภาพให้เหลือครึ่งนึง
    width: 500, // ปรับขนาดรูปให้มีความกว้าง 500 px
  });

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        3000,
        "PNG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  /*const handleUpload_image_Details = async (file) => {
        const image = await resizeFile(file);
        imageResize
            .play(URL.createObjectURL(file)) //แปลงไฟล์เป็น blob
            .then(async function (response) {
                const trans = dataURLtoFile(image, 'img.png')
                var formdata = new FormData();
                let token = localStorage.getItem("Token");
                formdata.append("image", trans, URL.createObjectURL(trans));
                var requestOptions = {
                    method: "POST",
                    body: formdata,
                    redirect: "follow",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };
                await fetch(`${baseURLV1}/upload`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        let res = JSON.parse(result);
                        let fullPath = `${baseURL}/uploads/${res.filename}`

                        //setListImg(listImg => [...listImg, fullPath])
                    })
                    .catch((error) => console.log("error", error));
            })
            .catch(function (error) {
                console.error(error);
            });
    };*/

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const onSubmit = async (data) => {
    let img = {};

    if (type == "CONTENT") {
      if (title_th === undefined || title_th === "") {
        return AlertError("กรุณากรอกชื่อกิจกรรม (TH)!!");
      }

      /*if (title_en === undefined || title_en === "") {
        return AlertError("กรุณากรอกชื่อกิจกรรม (EN)!!");
      }*/

      if (description_th === undefined || description_th === "") {
        return AlertError("กรุณากรอกรายละเอียดกิจกรรม (TH) !!");
      }

      if (description_en === undefined || description_en === "") {
        return AlertError("กรุณากรอกรายละเอียดกิจกรรม (EN)!!");
      }
      /*if (thumbnail_th === undefined || thumbnail_th === "") {
                return AlertError("กรุณากรอกรูปภาพหน้าหลัก (TH) !!");
            }
            if (thumbnail_en === undefined || thumbnail_en === "") {
                return AlertError("กรุณากรอกรูปภาพหน้าหลัก (EN) !!");
            }
            if (image_th === undefined || image_th === "") {
                return AlertError("รูปภาพหน้ารายละเอียด (TH)  !!");
            }
            if (image_en === undefined || image_en === "") {
                return AlertError("รูปภาพหน้ารายละเอียด (EN)  !!");
            }*/
    } else if (type == "LINK") {
      /*if (thumbnail_th === undefined || thumbnail_th === "") {
                return AlertError("กรุณากรอกรูปภาพหน้าหลัก (TH) !!");
            }
            if (thumbnail_en === undefined || thumbnail_en === "") {
                return AlertError("กรุณากรอกรูปภาพหน้าหลัก (EN) !!");
            }*/
      if (link === undefined || link === "") {
        return AlertError("กรุณากรอกลิงค์เว็ปไซต์ !!");
      }
    } else if (type == "PRIVILEGE") {
      /*if (thumbnail_th === undefined || thumbnail_th === "") {
                return AlertError("กรุณากรอกรูปภาพหน้าหลัก (TH) !!");
            }
            if (thumbnail_en === undefined || thumbnail_en === "") {
                return AlertError("กรุณากรอกรูปภาพหน้าหลัก (EN) !!");
            }*/
      if (reward === undefined || reward === "") {
        return AlertError("กรุณาเลือกรีวอร์ด !!");
      }
    }
    let temp1 = {};
    let temp2 = {};
    let temp3 = {};
    let temp4 = {};
    if (thumbnail_th != "") {
      temp1 = {
        thumbnail_th: thumbnail_th,
      };
    }

    if (thumbnail_en != "") {
      temp2 = {
        thumbnail_en: thumbnail_en,
      };
    }

    if (image_th != "") {
      temp3 = {
        image_th: image_th,
      };
    }

    if (image_en != "") {
      temp4 = {
        image_en: image_en,
      };
    }

    var events = {};

    if (type == "CONTENT") {
      events = {
        title_th: title_th,
        title_en: title_en,
        description_th: description_th,
        description_en: description_en,
        type: type,
        banner_category_id: banner_category_id,
        ...temp1,
        ...temp2,
        ...temp3,
        ...temp4,
        order_item: order_item,
        //group_condition_id: target == '' ? null : target,
        popupend: moment(popupend),
        popupstart: moment(popupstart),
      };
    } else if (type == "LINK") {
      events = {
        type: type,
        banner_category_id: banner_category_id,
        ...temp1,
        ...temp2,
        link: link,
        order_item: order_item,
        //group_condition_id: target == '' ? null : target,
        popupend: moment(popupend),
        popupstart: moment(popupstart),
      };
    } else if (type == "PRIVILEGE") {
      events = {
        type: type,
        banner_category_id: banner_category_id,
        ...temp1,
        ...temp2,
        privilege_id: reward,
        order_item: order_item,
        //group_condition_id: target == '' ? null : target,
        popupend: moment(popupend),
        popupstart: moment(popupstart),
      };
    }

    let apiUrls = `${baseURLV1}/banner/${props.location.state.id}`;
    let token = localStorage.getItem("Token");
    console.log(events);
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ไม่สามารถสร้างรายการได้ !! " + err,
          "error"
        );
      });
  };

  return (
    <>
      <Card>
        <CardHeader title="Edit Banner "></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              ประเภทกิจกรรม<span style={{ color: "red" }}>*</span>
            </p>
            <select
              name="cars"
              id="cars"
              disabled
              value={type}
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <option value="CONTENT">CONTENT</option>
              <option value="LINK">LINK</option>
              <option value="PRIVILEGE">PRIVILEGE</option>
            </select>
          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}></span>
              {intl.formatMessage({
                id: "###",
                defaultMessage: "กลุ่มเป้าหมาย",
              })}
              :{" "}
            </p>
            <select
              name="cars"
              id="cars"
              style={{ width: "530px" }}
              value={target}
              onChange={(e) => {
                // console.log(e.target.value)
                setTarget(e.target.value);
              }}
            >
              <option value={null}>All</option>
              {listTarget &&
                listTarget.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.title_th}
                    </option>
                  );
                })}
            </select>
          </div>
          {type == "CONTENT" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "ชื่อกิจกรรม (TH)",
                })}
                <span style={{ color: "red" }}>*</span>:{" "}
              </p>
              <input
                name="topic"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                value={title_th}
                onChange={(e) => setTitle_th(e.target.value)}
              />
            </div>
          )}

          {/*type == "CONTENT" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "ชื่อกิจกรรม (EN)",
                })}
                <span style={{ color: "red" }}>*</span>:{" "}
              </p>
              <input
                name="topic"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                value={title_en}
                onChange={(e) => setTitle_en(e.target.value)}
              />
            </div>
          )*/}

          {type == "CONTENT" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "รายละเอียดกิจกรรม (TH)",
                })}
                <span style={{ color: "red" }}>*</span>:{" "}
              </p>
              <input
                name="topic"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                value={description_th}
                onChange={(e) => setDescription_th(e.target.value)}
              />
            </div>
          )}

          {/*type == "CONTENT" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "รายละเอียดกิจกรรม (EN)",
                })}
                <span style={{ color: "red" }}>*</span>:{" "}
              </p>
              <input
                name="topic"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                value={description_en}
                onChange={(e) => setDescription_en(e.target.value)}
              />
            </div>
          )*/}

          {(type == "CONTENT" || type == "LINK" || type == "PRIVILEGE") && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "รูปภาพหน้าหลัก (TH)",
                })}
                <span style={{ color: "red" }}>*</span>: <br></br>
                (600*340 px)
              </p>
              <div
                className="d-flex"
                style={{
                  width: "530px",
                }}
              >
                <input
                  name="item_image_path"
                  style={{
                    flexGrow: "1",
                    height: "38px",
                    backgroundColor: "#F4F6F9",
                    borderRadius: "5px",
                    borderWidth: "0",
                  }}
                  value={item_image_path}
                />

                <span
                  className="btn btn-primary btn-file wbt"
                  style={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                  }}
                >
                  {intl.formatMessage({
                    id: "104025",
                    defaultMessage: "Upload/Edit",
                  })}
                  <input type="file" onChange={handleChangeItem_image_path} />
                </span>

                <button
                  type="button"
                  className="btn btn-danger wbt"
                  onClick={removeImageItem_image_path}
                >
                  {intl.formatMessage({
                    id: "104026",
                    defaultMessage: "delete",
                  })}
                </button>
                <p style={{ position: "absolute", marginTop: "40px" }}>
                  ไม่ควรเกิน 1 MB
                </p>
              </div>
            </div>
          )}

          {(type == "CONTENT" || type == "LINK" || type == "PRIVILEGE") && (
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50%",
              }}
            >
              {stateItem_image_path.imageURLItem_image_path ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={stateItem_image_path.imageURLItem_image_path}
                />
              ) : item_image_path ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={item_image_path}
                />
              ) : null}
            </div>
          )}

          {/*(type == "CONTENT" || type == "LINK" || type == "PRIVILEGE") && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "รูปภาพหน้าหลัก (EN)",
                })}
                <span style={{ color: "red" }}>*</span>: <br></br>
                (600*340 px)
              </p>
              <div
                className="d-flex"
                style={{
                  width: "530px",
                }}
              >
                <input
                  name="item_image_path"
                  style={{
                    flexGrow: "1",
                    height: "38px",
                    backgroundColor: "#F4F6F9",
                    borderRadius: "5px",
                    borderWidth: "0",
                  }}
                  value={item_image_path2}
                />

                <span
                  className="btn btn-primary btn-file wbt"
                  style={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                  }}
                >
                  {intl.formatMessage({
                    id: "104025",
                    defaultMessage: "Upload/Edit",
                  })}
                  <input type="file" onChange={handleChangeItem_image_path2} />
                </span>

                <button
                  type="button"
                  className="btn btn-danger wbt"
                  onClick={removeImageItem_image_path2}
                >
                  {intl.formatMessage({
                    id: "104026",
                    defaultMessage: "delete",
                  })}
                </button>
                <p style={{ position: "absolute", marginTop: "40px" }}>
                  ไม่ควรเกิน 1 MB
                </p>
              </div>
            </div>
          )*/}

          {/*(type == "CONTENT" || type == "LINK" || type == "PRIVILEGE") && (
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50%",
              }}
            >
              {stateItem_image_path2.imageURLItem_image_path ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={stateItem_image_path2.imageURLItem_image_path}
                />
              ) : item_image_path2 ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={item_image_path2}
                />
              ) : null}
            </div>
          )*/}

          {type == "CONTENT" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "รูปภาพหน้ารายละเอียด (TH)",
                })}
                <span style={{ color: "red" }}>*</span>: <br></br>
              </p>
              <div
                className="d-flex"
                style={{
                  width: "530px",
                }}
              >
                <input
                  name="item_image_path"
                  style={{
                    flexGrow: "1",
                    height: "38px",
                    backgroundColor: "#F4F6F9",
                    borderRadius: "5px",
                    borderWidth: "0",
                  }}
                  value={item_image_path3}
                />

                <span
                  className="btn btn-primary btn-file wbt"
                  style={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                  }}
                >
                  {intl.formatMessage({
                    id: "104025",
                    defaultMessage: "Upload/Edit",
                  })}
                  <input type="file" onChange={handleChangeItem_image_path3} />
                </span>

                <button
                  type="button"
                  className="btn btn-danger wbt"
                  onClick={removeImageItem_image_path3}
                >
                  {intl.formatMessage({
                    id: "104026",
                    defaultMessage: "delete",
                  })}
                </button>
                <p style={{ position: "absolute", marginTop: "40px" }}>
                  ไม่ควรเกิน 1 MB
                </p>
              </div>
            </div>
          )}

          {type == "CONTENT" && (
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50%",
              }}
            >
              {stateItem_image_path3.imageURLItem_image_path ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={stateItem_image_path3.imageURLItem_image_path}
                />
              ) : item_image_path3 ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={item_image_path3}
                />
              ) : null}
            </div>
          )}

          {/*type == "CONTENT" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "รูปภาพหน้ารายละเอียด (EN)",
                })}
                <span style={{ color: "red" }}>*</span>: <br></br>
              </p>
              <div
                className="d-flex"
                style={{
                  width: "530px",
                }}
              >
                <input
                  name="item_image_path"
                  style={{
                    flexGrow: "1",
                    height: "38px",
                    backgroundColor: "#F4F6F9",
                    borderRadius: "5px",
                    borderWidth: "0",
                  }}
                  value={item_image_path4}
                />

                <span
                  className="btn btn-primary btn-file wbt"
                  style={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                  }}
                >
                  {intl.formatMessage({
                    id: "104025",
                    defaultMessage: "Upload/Edit",
                  })}
                  <input type="file" onChange={handleChangeItem_image_path4} />
                </span>

                <button
                  type="button"
                  className="btn btn-danger wbt"
                  onClick={removeImageItem_image_path4}
                >
                  {intl.formatMessage({
                    id: "104026",
                    defaultMessage: "delete",
                  })}
                </button>
                <p style={{ position: "absolute", marginTop: "40px" }}>
                  ไม่ควรเกิน 1 MB
                </p>
              </div>
            </div>
                )*/}

          {type == "CONTENT" && (
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50%",
              }}
            >
              {stateItem_image_path4.imageURLItem_image_path ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={stateItem_image_path4.imageURLItem_image_path}
                />
              ) : item_image_path4 ? (
                <img
                  style={{
                    width: "250px",
                  }}
                  src={item_image_path4}
                />
              ) : null}
            </div>
          )}

          {type == "LINK" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                {intl.formatMessage({
                  id: "###",
                  defaultMessage: "ลิงค์เว็ปไซต์",
                })}
                <span style={{ color: "red" }}>*</span>:{" "}
              </p>
              <input
                name="topic"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                value={link}
                onChange={(e) => setLink(e.target.value)}
              />
            </div>
          )}

          {type == "PRIVILEGE" && (
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                เลือกรีวอร์ด<span style={{ color: "red" }}>*</span>
              </p>
              <select
                as="select"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                value={reward}
                onChange={(e) => setReward(e.target.value)}
              >
                <option value="">
                  {intl.formatMessage({
                    id: "###",
                    defaultMessage: "กรุณาเลือก",
                  })}
                </option>
                {event &&
                  event.map((result, index) => {
                    return (
                      <option key={index} value={result.id}>
                        {result.deal_detail_short}
                      </option>
                    );
                  })}
              </select>
            </div>
          )}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}></span>
              ลำดับการแสดง
            </p>
            <input
              name="displayOrder"
              type="number"
              onKeyDown={(e) =>
                symbolsArr.includes(e.key) && e.preventDefault()
              }
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={order_item}
              onChange={(displayOrder) => {
                if (displayOrder.target.value >= 0) {
                  setOrder_item(displayOrder.target.value);
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              {intl.formatMessage({ id: "###", defaultMessage: "Popup Start" })}
              <span style={{ color: "red" }}>*</span>:{" "}
            </p>
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <input
                id="datestart"
                type="datetime-local"
                defaultValue="yyyy-mm-dd"
                value={popupstart}
                style={{
                  height: "38px",
                  width: "185px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(data) =>
                  setPopupstart(
                    data.target.value == "NULL" ? null : data.target.value
                  )
                }
              />
            </div>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              {intl.formatMessage({ id: "###", defaultMessage: "Popup End" })}
              <span style={{ color: "red" }}>*</span>:{" "}
            </p>
            <input
              id="datestart"
              type="datetime-local"
              min={popupstart}
              value={popupend}
              defaultValue="yyyy-mm-dd"
              style={{
                height: "38px",
                width: "185px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(data) =>
                setPopupend(
                  data.target.value == "NULL" ? null : data.target.value
                )
              }
            />
          </div>

          <Link to="/BannerManagement">
            <button type="button" className="btn btn-secondary wbt mr-5">
              {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
            </button>
          </Link>
          <button className="btn btn-primary" onClick={() => onSubmit()}>
            {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
          </button>
        </CardBody>
      </Card>
    </>
  );
};
